import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { HRMTable } from '../components/hrm_table'
import { useMeta } from '../../contexts'
import HrmLoader from '../components/hrm_loader'
import NoData from '../../assets/No-Search-Result.png'
import { HrmFormInput } from '../components/hrm_input'
import { format } from 'date-fns'
import { useNavigate } from 'react-router-dom'
import DeleteModal from '../modals/delete_model'
import { Plus } from 'lucide-react'
import { ACTIONS } from '../../constants/actions'
import { adminMetaInfoColumns } from '../../constants/data_columns/meta_info'
import { componentRoutes } from '../../constants/componentRoutes'
import MetaInfoUpdate from '../modals/edit_meta-info'
import { APIS } from '../../api'
import axios from '../../api/axios'
import ViewModal from '../modals/View_modal'

const MetaInfo = () => {
  const [workUpdateList, setWorkUpdateList] = useState([])
  const [metaInfoList, setMetaInfoList] = useState([])
  const [isDeleteFormVisible, setDeleteFormVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const [selectedRow, setSelectedRow] = useState(null)
  const [isWorkUpdateModalVisible, setWorkUpdateModalVisible] = useState(false)
  const [isMetaInfoEditFormVisible, setMetaInfoEditFormVisible] =
    useState(false)
  const [metaLoader, setMetaLoader] = useState(false)
  const [selectedViewId, setSelectedViewId] = useState(null)
  const [isViewFormVisible, setIsViewFormVisible] = useState(false)

  const { onLoadMetaInfo, metaInfo, onDeleteMetaInfo } = useMeta()

  const fetchData = async () => {
    setMetaLoader(true)
    try {
      const { data } = await axios.post(APIS.LIST_META_TAG)
      if (data.code == 1) {
        // setPages(data?.data);
        setMetaInfoList(
          data?.data?.map(item => {
            return {
              id: item.id,
              page: item.name,
              meta_title: item.meta_tag,
              meta_description: item.meta_desc
            }
          })
        )
      } else {
        setMetaInfoList([])
      }
    } catch (error) {
      console.error('Error fetching data:', error)
      setMetaInfoList([])
      setMetaLoader(false)
    } finally {
      setMetaLoader(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [isMetaInfoEditFormVisible])

  const navigate = useNavigate()

  const handelAddMetaInfo = async () => {
    navigate(componentRoutes.addMetaInfo)
  }

  const handleView = async row => {
    if (!row) return
    try {
      setSelectedViewId(row)
      setIsViewFormVisible(true) // Open the modal
    } catch (error) {
      console.error('Failed to fetch contact details:', error)
    }
  }

  const handleDelete = async () => {
    if (!selectedId) return

    const response = await onDeleteMetaInfo(selectedId)
    if (response.code == 1) {
      setDeleteFormVisible(false)
      setSelectedId(null)
      fetchData()
    }
  }

  const onSelectAction = useCallback((row, value) => {
    if (ACTIONS.DELETE === value) {
      setSelectedId(row.id)
      setDeleteFormVisible(true)
    } else if (ACTIONS.EDIT === value) {
      setSelectedRow(row)
      setMetaInfoEditFormVisible(true)
    } else if (ACTIONS.VIEW === value) {
      // Handle View action
      setSelectedViewId(row)
      setIsViewFormVisible(true)
      handleView(row)
    } else {
    }
  }, [])

  const columns = useMemo(() => {
    return adminMetaInfoColumns({ onSelectAction })
  }, [onSelectAction])

  useEffect(() => {
    if (!setMetaInfoEditFormVisible) {
      setSelectedRow(null)
    }
  }, [isMetaInfoEditFormVisible])

  return (
    <>
      <div className='col-span-12 md:order-1 xl:col-span-8 2xl:col-span-6'>
        <h5 className='mb-2'>Meta Information</h5>
      </div>
      <div className='card'>
        <div className='card-body'>
          <div className='mb-5'>
            <div className='grid grid-cols-1 gap-5 lg:grid-cols-12 items-center'>
              <div className='xl:col-span-2 xl:col-start-11'>
                <div className='ltr:lg:text-right rtl:lg:float-left'>
                  <button
                    type='button'
                    onClick={handelAddMetaInfo}
                    className='text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20'
                  >
                    <Plus className='inline-block size-4' />
                    <span className='align-middle'>Add Meta Info</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {metaLoader ? (
            <HrmLoader />
          ) : metaInfoList.length > 0 ? (
            <HRMTable data={metaInfoList} columns={columns} />
          ) : (
            <img
              src={NoData}
              alt='No Data Available'
              className='w-200 h-200 mx-auto'
            />
          )}

          {isDeleteFormVisible && (
            <DeleteModal
              isVisible={isDeleteFormVisible}
              onClose={() => {
                setDeleteFormVisible(false)
                setSelectedId(null)
              }}
              onConfirm={handleDelete}
              title='Delete Meta Info'
              description="Are you sure you want to delete this page's meta Info?"
            />
          )}
          <ViewModal
            isVisible={isViewFormVisible}
            onClose={() => {
              setIsViewFormVisible(false)
              setSelectedViewId(null)
            }}
            onConfirm={handleView}
            title='View Contact'
            description='dsfsdff'
            data={selectedViewId?.meta_description}
          />
          {isMetaInfoEditFormVisible && (
            <MetaInfoUpdate
              isMetaInfoEditFormVisible={isMetaInfoEditFormVisible}
              onClose={() => {
                setMetaInfoEditFormVisible(false)
                setSelectedId(null)
              }}
              initialValues={selectedRow}
            />
          )}
        </div>
      </div>
    </>
  )
}

export default MetaInfo
